import styled from 'styled-components'

export const AuthorName = styled.p`
  margin-bottom: 0px;
  margin-top: 0px;
  font-size: 16px;
  color: ${ props => props.theme.text };
`